import apiClient from './client';

export interface ActivityLogUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
}

export interface ActivityLog {
  id: string;
  userId: string | null;
  activityType: string;
  activityDescription: string | null;
  metadata: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
  user: ActivityLogUser | null;
}

export interface ActivityQuery {
  page?: number;
  limit?: number;
  activityType?: string;
  userId?: string;
  from?: string;
  to?: string;
}

export const activityApi = {
  getActivities: (params: ActivityQuery = {}) => {
    return apiClient.get('/activity', { params });
  },

  getActivityTypes: () => {
    return apiClient.get('/activity/types');
  },

  getFilterOptions: (params: {
    activityType?: string;
    userId?: string;
    from?: string;
    to?: string;
  } = {}) => {
    return apiClient.get('/activity/filter-options', { params });
  },

  logPageView: (path: string, title: string, entityId?: string, entityName?: string) => {
    return apiClient.post('/activity/page-view', { path, title, entityId, entityName });
  },

  deleteActivities: (params: {
    activityType?: string;
    userId?: string;
    from?: string;
    to?: string;
    confirmDeleteAll?: boolean;
  }) => {
    return apiClient.delete('/activity', { params });
  },

  deleteActivitiesByIds: (ids: string[]) => {
    // Send IDs in the request body (axios supports a body on DELETE via `data`).
    return apiClient.delete('/activity', { data: { ids } });
  },
};
